import axios from "axios";

export const Token = {
    get: function () {
        return localStorage.getItem("token");
    },
};

axios.defaults.headers.common['Content-Type'] = 'application/json';

axios.interceptors.response.use(
    (response) => {
        return response;
    },
    async (error) => {
        const url = error.config.url
        if (url) {
            const u = new URL(url)
            if (u.pathname === '/auth/login') {
                return Promise.reject(error)
            }
        }
        if (error.response && error.response.status === 426 && error.response.data?.redirectToDifferentDomain) {
            const newUrl = new URL(error.response.data?.redirectToDifferentDomain)
            if (window.location.origin !== newUrl.origin) {
                const auth = error.config.headers?.Authorization?.replace("Bearer ", "")
                newUrl.searchParams.set("token", auth)
                const u = localStorage.getItem("user")
                newUrl.searchParams.set("user", btoa(u))
                newUrl.pathname = window.location.pathname
                console.log("newUrl", newUrl.toString())
                setTimeout(() => window.open(newUrl.toString(), '_top'), 500);
                localStorage.setItem("clearOnNextEntry", "true")
                // Se o cara voltar pro domínio original por algum motivo, tem que logar novamnete
                return Promise.resolve({ data: [] })
            }
        } else if (error.response && error.response.status === 401) {
            const redirectUrl = error.response.data?.redirectTo;

            if (redirectUrl) {
                localStorage.removeItem("user")
                localStorage.removeItem("token")
                const currentLocation = window.location.href;
                const state = encodeURIComponent(currentLocation);

                const url = new URL(redirectUrl);
                url.searchParams.set('state', state);

                window.location.href = url.toString();

                return Promise.resolve();
            } else {
                window.location.href = "/login";
            }
        }
        return Promise.reject(error);
    }
);
export const list = async (url, returnResult, params) => {
    try {
        const { data } = await axios.get(url, {
            params,
            headers: {
                Authorization: "Bearer " + Token.get(),
            },
        });

        return { ...data, success: true };
    } catch (error) {
        return {
            message:
                error.response && error.response.data && error.response.data.message
                    ? error.response && error.response.data && error.response.data.message
                    : "Erro inesperado " + error.toString(),
            success: false,
        };
    }

};

export const get = async (url, params = {}) => {
    try {
        const { data } = await axios.get(url, {
            headers: {
                Authorization: "Bearer " + Token.get(),
            },
            params
        });
        return { data, success: true };
    } catch (error) {
        return {
            message:
                error.response && error.response.data && error.response.data.message
                    ? error.response && error.response.data && error.response.data.message
                    : "Erro inesperado " + error.toString(),
            success: false,
        };
    }
}

export const listData = async (url, params = {}) => {
    try {
        const { data } = await axios.get(url, {
            headers: {
                'Authorization': 'Bearer ' + Token.get(),
            },
            params
        });

        return { data, success: true };
    } catch (error) {
        return {
            message: error.response && error.response.data && error.response.data.message ?
                error.response && error.response.data && error.response.data.message :
                'Erro inesperado ' + error.toString(),
            success: false,
            status: error.response && error.response.status,
        }
    }
};

export const post = async (url, body) => {
    try {
        const { data } = await axios.post(url, body, {
            headers: {
                'Authorization': "Bearer " + Token.get(),
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
            withCredentials: false,
        });

        return { ...data, success: true };
    } catch (error) {
        return {
            message:
                error.response && error.response.data && error.response.data.message
                    ? error.response && error.response.data && error.response.data.message
                    : "Erro inesperado: " + error.message,
            success: false,
        };
    }
};

export const put = async (url, body) => {
    try {
        const { data } = await axios.put(url, body, {
            headers: {
                Authorization: "Bearer " + Token.get(),
            },
        });

        return { ...data, success: true };
    } catch (error) {
        return {
            message:
                error.response && error.response.data && error.response.data.message
                    ? error.response && error.response.data && error.response.data.message
                    : "Erro inesperado " + error.toString(),
            success: false,
        };
    }
};

export const del = async (url, body) => {
    try {
        const { data } = await axios.delete(url, {
            data: body,
            headers: {
                Authorization: "Bearer " + Token.get(),
            },
        });

        return { ...data, success: true };
    } catch (error) {

        return {
            message: error.response && error.response.data && error.response.data.message ?
                error.response && error.response.data && error.response.data.message :
                'Erro inesperado ' + error.toString(),
            success: false,
        }
    }
};

export const destroy = async url => {
    try {
        await axios.delete(url, {
            headers: {
                'Authorization': 'Bearer ' + Token.get(),
            },
        });

        return true;
    } catch (error) {
        if (error.response && error.response.data) {
            console.log(
                error.response.data.display_message || error.response.data.message || error.response.statusText
            );
        } else {
            console.log('Erro inesperado');
        }
    }
    return false;
};

export const patch = async (url, body) => {
    try {
        const { data } = await axios.patch(url, body, {
            headers: {
                Authorization: "Bearer " + Token.get(),
            },
        });

        if (typeof data === "object") {
            console.log("Ok");
        } else {
            throw new Error("Erro");
        }

        return true;
    } catch (error) {
        if (error.response && error.response.data) {
            console.log(
                error.response.data.display_message ||
                error.response.data.message ||
                error.response.statusText
            );
        } else {
            console.log("Erro inesperado");
        }
        return false;
    }
};

export default {
    patch,
    list,
    listData,
    get,
    post,
    del,
    destroy,
    put
}